export function getInitialsFromName(
  firstName?: string,
  lastName?: string,
  displayName?: string,
) {
  if (firstName && lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  }

  if (displayName) {
    const parts = displayName.trim().split(/\s+/);
    if (parts.length >= 2) {
      return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
    }
    return displayName.slice(0, 2).toUpperCase();
  }

  return '??';
}
